import React from "react";
import { Text, TextProps } from "@chakra-ui/react";

interface Props extends TextProps {
  text?: string;
  type?: "03" | "02" | "01" | "footer";
}

const VeendText = ({ text, type = "02", color, children, ...props }: Props) => {
  const _getFontFace = () => {
    switch (type) {
      case "01":
        return { fontSize: "14px", fontWeight: 500, lineHeight: "28px" };
      case "02":
        return { fontSize: "16px", fontWeight: 400, lineHeight: "30px" };
      case "03":
        return { fontSize: "18px", fontWeight: 500, lineHeight: "34px" };
      case "footer":
        return { fontSize: "12px", fontWeight: 450, lineHeight: "24px" };
      default:
        return { fontSize: "16px", fontWeight: 450, lineHeight: "30px" };
    }
  };
  return (
    <Text {..._getFontFace()} color={color || "neutral.400"} {...props}>
      {text || children}
    </Text>
  );
};

export default VeendText;
